import React, { useState, useEffect } from "react";
import { DatePicker, Select } from "antd";

import ModalComponent from "../../../components/modalComponent/ModalComponent";

import { getRolesList } from "../../../redux/actions/userActions";
import { connect } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import UserVacationRow from "../components/UserVacationRow";
import QuickLookModalContent from "../../../components/presence/QuickLookModalContent";
import ValidateModalContent from "../../../components/presence/ValideModalContent";
import { deleteVacationApi } from "../sagas/vacation.api";
import { getVacationsList, rejectVacation, validateVacation } from "../actions/presence";
import { roles, VACATION_REQUEST_STATUS_ID, VACATION_REQUEST_STATUS_LABELS } from "../../../configs/constants";
import { computeEventInfosFromRequest } from "../utils/utils";
import { MODAL_TYPE_VACATIONS } from "../utils/constants";
import { selectUserRoleId } from "../../../redux/selectors/user";

const { Option } = Select;

const Conges = ({ userId, getUsersRolesList, token, accept, reject, requests = [], fetchData, roleId, rolesList }) => {
  const [requestType, setRequestType] = useState("request_date");
  const [modalType, setModalType] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [rangeDate, setRangeDate] = useState([moment().add(-1, "months"), moment().add(1, "weeks")]);
  const [selectedClient, setSelectedClient] = useState();
  const [selectedUserEmail, setSelectedUserEmail] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedVacationType, setSelectedVacationType] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedUserRoleId, setSelectedUserRoleId] = useState(undefined);
  const [usersRolesList, setUsersRolesList] = useState([]);
  const [isModalConfirmDeleteVacationOpen, setIsModalConfirmDeleteVacationOpen] = useState(false);
  const [vacationToDeleteId, setVacationToDeleteId] = useState(-1);

  useEffect(() => {
    if (isEmpty(rolesList)) getUsersRolesList();
  }, []);

  useEffect(() => {
    setUsersRolesList(rolesList);
  }, [rolesList]);

  useEffect(() => {
    if (Array.isArray(rangeDate)) {
      const filters = computeFilters();
      fetchData(filters);
    }
  }, [requestType, rangeDate, selectedUserRoleId]);

  const requestDeleteVacation = async () => {
    const response = await deleteVacationApi({ _id: vacationToDeleteId }, token);

    if (response.status.id === 4) {
      setVacationToDeleteId(-1);
      setIsModalConfirmDeleteVacationOpen(false);
      const filters = computeFilters();
      fetchData(filters);
    }
  };

  const manangeButtonPressed = ({ request, modalType }) => {
    setSelectedRequest(request);
    setModalType(modalType);
    setModalOpen(true);
  };

  const manageDeleteVacation = vacationId => {
    setVacationToDeleteId(vacationId);
    setIsModalConfirmDeleteVacationOpen(true);
  };

  const computeFilters = () => {
    if (!Array.isArray(rangeDate) || rangeDate.length !== 2) return {};
    const startDate = rangeDate[0];

    const endDate = rangeDate[1];

    const filters = {
      [requestType]: { $gte: { $date: startDate }, $lte: { $date: endDate } }
    };
    if (selectedUserRoleId) filters.user_role_id = selectedUserRoleId;
    return filters;
  };
  const computePayload = vacation => {
    const filters = computeFilters();
    const payload = {
      vacation: { _id: vacation._id },
      filters,
      refreshVacations: true
    };
    return payload;
  };

  const uniqueListClients = [
    ...new Set(
      requests
        .map(request => {
          const clients = request.clients || [];
          return clients.map(c => c.label);
        })
        .flat()
        .sort((a, b) => (a > b ? 1 : -1))
    )
  ];
  const uniqueListEmails = [...new Set(requests.map(request => request.user_email))];
  const uniqueListStatus = [...new Set(requests.map(request => request.status.label))];
  const uniqueListVacationTypes = [...new Set(requests.map(request => request.type.label))];
  useEffect(() => {
    if (uniqueListStatus.indexOf("En attente de validation") > -1) {
      setSelectedStatus("En attente de validation");
    }
  }, [requests]);
  const eventInfos = computeEventInfosFromRequest(selectedRequest);

  return (
    <div className="w-full">
      <div className="text-3xl font-bold text-gray-900">Gestion des Congés</div>
      <div className={"mt-8 mb-3 flex"}>
        <div
          className={`
          ${requestType === "request_date" ? "bg-green-400" : "bg-green-200"}
          rounded-full text-white py-3 px-4 mx-2 cursor-pointer`}
          onClick={() => {
            if (requestType !== "request_date") setRequestType("request_date");
          }}
        >
          Date de la demande
        </div>
        <div
          className={`
          ${requestType === "start_date" ? "bg-green-400" : "bg-green-200"}
          rounded-full text-white py-3 px-4 mx-2 cursor-pointer`}
          onClick={() => {
            if (requestType !== "start_date") setRequestType("start_date");
          }}
        >
          Début de la période
        </div>
        <DatePicker.RangePicker
          onChange={selectedRangeDate => {
            setRangeDate(selectedRangeDate);
          }}
          defaultValue={rangeDate}
          format={"DD/MM/YYYY"}
          placeholder={["Début", "Fin"]}
        />
        <div className="mx-2">
          <Select
            allowClear
            showSearch
            value={selectedClient}
            placeholder="Dossier"
            style={{ width: 200 }}
            onChange={setSelectedClient}
          >
            {uniqueListClients.map(clients => (
              <Option key={clients} value={clients}>
                {clients}
              </Option>
            ))}
          </Select>
        </div>
        <div className="mx-2">
          <Select
            allowClear
            showSearch
            placeholder="Personne"
            style={{ width: 200 }}
            onChange={email => (email ? setSelectedUserEmail(email) : setSelectedUserEmail(null))}
          >
            {uniqueListEmails.map(userEmail => (
              <Option key={userEmail} value={userEmail}>
                {userEmail}
              </Option>
            ))}
          </Select>
        </div>
        <div className="mx-2">
          <Select
            allowClear
            placeholder="Statut de la demande"
            style={{ width: 200 }}
            onChange={setSelectedStatus}
            value={selectedStatus}
          >
            {uniqueListStatus.map(status => (
              <Option key={status} value={status}>
                {status}
              </Option>
            ))}
          </Select>
        </div>
        <div className="mx-2">
          <Select
            allowClear
            placeholder="Type de congés"
            style={{ width: 200 }}
            onChange={vacationType =>
              vacationType ? setSelectedVacationType(vacationType) : setSelectedVacationType(null)
            }
          >
            {uniqueListVacationTypes.map(vacationType => (
              <Option key={vacationType} value={vacationType}>
                {vacationType}
              </Option>
            ))}
          </Select>
        </div>
        {(roleId === roles.DIRECTOR || roleId === roles.ADMIN) && (
          <div className="mx-2">
            <Select
              allowClear
              showSearch
              placeholder="Rôle"
              style={{ width: 200 }}
              onChange={userId => {
                userId ? setSelectedUserRoleId(userId) : setSelectedUserRoleId(undefined);
              }}
              value={selectedUserRoleId}
            >
              {usersRolesList &&
                usersRolesList.map(roleItem => (
                  <Select.Option key={roleItem.id} value={roleItem.id}>
                    {roleItem.label_fr}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )}
        <div
          className={"bg-orange-500 rounded-full text-white py-3 px-4 mx-2 cursor-pointer"}
          onClick={() => {
            if (selectedStatus !== VACATION_REQUEST_STATUS_LABELS.PENDING)
              setSelectedStatus(VACATION_REQUEST_STATUS_LABELS.PENDING);
            else setSelectedStatus(null);
          }}
        >
          {selectedStatus !== VACATION_REQUEST_STATUS_LABELS.PENDING
            ? "Voir congés non traités uniquement"
            : "Voir toutes les requêtes"}
        </div>
      </div>
      <div className="flex flex-col my-8">
        <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Nom
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Statut
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Date de la demande
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Type de congé
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Periode
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Durée
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    PJ
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Date de validation / refus
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {requests
                  .filter(
                    request =>
                      (!selectedUserEmail || selectedUserEmail === request.user_email) &&
                      (!selectedStatus || selectedStatus === request.status.label) &&
                      (!selectedClient || request.clients.map(c => c.label).includes(selectedClient)) &&
                      (!selectedVacationType || selectedVacationType === request.type.label)
                  )
                  .map(request => (
                    <UserVacationRow
                      request={request}
                      key={request._id}
                      manangeButtonPressed={manangeButtonPressed}
                      manageDeleteVacation={manageDeleteVacation}
                      roleId={roleId}
                      userId={userId}
                    />
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ModalComponent
        title={
          selectedRequest
            ? `Demande de ${selectedRequest.user_fullname} pour le ${moment(selectedRequest.start_date).format(
                "DD/MM/YYYY"
              )} `
            : "Demande de congé"
        }
        showModal={modalOpen}
        closeModal={() => {
          setModalOpen(false);
        }}
      >
        {modalType === MODAL_TYPE_VACATIONS.VALIDATE ? (
          <ValidateModalContent
            eventInfos={eventInfos}
            displayAccept={
              selectedRequest &&
              selectedRequest.status &&
              selectedRequest.status.id !== VACATION_REQUEST_STATUS_ID.VALIDATED
            }
            accept={vacation => {
              const payload = computePayload(vacation);
              accept(payload);
            }}
            reject={vacation => {
              const payload = computePayload(vacation);
              reject(payload);
            }}
            closeModal={() => {
              setModalOpen(false);
            }}
          />
        ) : (
          <QuickLookModalContent
            eventInfos={eventInfos}
            displayOnlyAttachments={modalType === MODAL_TYPE_VACATIONS.ATTACHMENTS}
            attachments={selectedRequest ? selectedRequest.attachements : []}
          />
        )}
      </ModalComponent>
      <ModalComponent
        title="Supprimer le congé"
        showModal={isModalConfirmDeleteVacationOpen}
        closeModal={() => setIsModalConfirmDeleteVacationOpen(false)}
      >
        <div className="mt-6 flex justify-center">
          <div
            className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full p-btn-grey text-white"
            onClick={() => setIsModalConfirmDeleteVacationOpen(false)}
          >
            Annuler
          </div>
          <div
            className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
            onClick={() => {
              requestDeleteVacation();
            }}
          >
            Confirmer
          </div>
        </div>
      </ModalComponent>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    requests: state.presence.vacationRequests,
    isLoading: state.presence.isLoading,
    roleId: selectUserRoleId(state),
    userId: state.userInfos._id,
    rolesList: (state.user && state.user.rolesList) || []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    reject: payload => {
      dispatch(rejectVacation(payload));
    },
    accept: payload => {
      dispatch(validateVacation(payload));
    },
    fetchData: filters => {
      dispatch(getVacationsList(filters));
    },
    getUsersRolesList: () => {
      dispatch(getRolesList());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Conges);



// WEBPACK FOOTER //
// src/modules/presence/conges/conges.js